// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // <-- Add this

const firebaseConfig = {
  apiKey: "AIzaSyDX9GsFZrE3of0sTpsYU-Cj8ZA0vGa_IVk",
  authDomain: "bolo-app-89001.firebaseapp.com",
  projectId: "bolo-app-89001",
  storageBucket: "bolo-app-89001.appspot.com", // <-- fix typo (.app to .appspot.com)
  messagingSenderId: "503670198993",
  appId: "1:503670198993:web:aec15e55c3ae08f1056bf0",
  measurementId: "G-CETSQVGT2S"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app); // <-- Add this
